import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ palette }) => ({
  rootBox: {
    backgroundColor: palette.primary[800],
    color: palette.primary[50]
  }
}))
